import { render, staticRenderFns } from "./labelFiltr.vue?vue&type=template&id=5930c678&scoped=true&"
import script from "./labelFiltr.vue?vue&type=script&lang=js&"
export * from "./labelFiltr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930c678",
  null
  
)

export default component.exports